
export default {
  name: 'ABtn',
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: '',
    },
    typeMenu: {
      type: Boolean,
      default: false,
    },
    boxIcon: {
      type: String,
      default: '',
    },
    boxType: {
      type: String,
      default: '',
    },
    boxSize: {
      type: String,
      default: '',
    },
    boxIconClass: {
      type: String,
      default: '',
    },
  },
};
